<ul class="list-group list-group-flush">
    <ng-template ngFor let-entity [ngForOf]="entities" let-i="index">
        <label for="mercado_{{indexUnidadeNegocio}}_{{i}}" class="col-form-label">
            Mercado
        </label>        
        <li class="list-group-item select">
            <div class="input-group">
                <div class="input-group-prepend delete" *ngIf="canEdit">
                    <button type="button" class="btn btn-light btn-delete" (click)="delete(i)">
                        <i class="far fa-trash-alt" aria-hidden="true"></i>
                    </button>
                </div>
                <select class="form-control" name="mercado_{{indexUnidadeNegocio}}_{{i}}" id="mercado_{{indexUnidadeNegocio}}_{{i}}" 
                    [ngModel]="entity.idMercado || ''" (ngModelChange)="onSelectMercado(entity, $event)"
                    #mercado="ngModel" [required]="entity.naturezasVendas?.length > 0" [disabled]="!canEdit">
                    <option value="">NÃO INFORMADO</option>
                    <optgroup label="ATIVOS" *ngIf="(mercados | unidadeNegocioMercadoSituacaoFilter: mercadoSituacaoAtivo)?.length > 0">
                        <option *ngFor="let unidadeNegocioMercado of mercados | unidadeNegocioMercadoSituacaoFilter: mercadoSituacaoAtivo" [ngValue]="unidadeNegocioMercado.idMercado">{{unidadeNegocioMercado.mercado?.nome}}</option>
                    </optgroup>
                    <optgroup label="INATIVOS" *ngIf="(mercados | unidadeNegocioMercadoSituacaoFilter: mercadoSituacaoInativo)?.length > 0">
                        <option *ngFor="let unidadeNegocioMercado of mercados | unidadeNegocioMercadoSituacaoFilter: mercadoSituacaoInativo" [ngValue]="unidadeNegocioMercado.idMercado" disabled>{{unidadeNegocioMercado.mercado?.nome}}</option>
                    </optgroup>                
                </select>                         
            </div>
    
            <div class="container-children">
                <sgt-cliente-unidade-negocio-natureza-venda
                    #naturezaVendaForm
                    [canEdit]="canEdit"
                    [idCliente]="idCliente"
                    [idUnidadeNegocio]="idUnidadeNegocio"
                    [nomeUnidadeNegocio]="nomeUnidadeNegocio"
                    [indexUnidadeNegocio]="indexUnidadeNegocio"
                    [idMercado]="entity.idMercado"
                    [nomeMercado]="entity.nomeMercado"
                    [indexMercado]="i"
                    [itensTipos]="itensTipos"
                    [entities]="entity.naturezasVendas">
                </sgt-cliente-unidade-negocio-natureza-venda>
            </div>        
        </li>
    </ng-template>    
    <li class="list-group-item no-entities" *ngIf="!entities || entities.length === 0">
        Nenhum Mercado Adicionado
    </li>
    <li class="list-group-item options" *ngIf="canEdit">
        <button type="button" class="btn btn-primary btn-add" (click)="insert()">
            <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Mercado
        </button>
    </li>
</ul>